import useGoalInfo from './useGoalInfo';
import useIconicSubscriptionInfo from './useIconicSubscriptionInfo';
import useGoalBenefits from './useGoalBenefits';
import usePriceHikeInfo from './usePriceHikeInfo';
import useGoalPageStaticContent from './useGoalPageStaticContent';
import useGoalFAQs from './useGoalFAQs';
import usePlatformGoalBenefits from './usePlatformGoalBenefits';

const useFullGoalInfo = ({
  isK12,
  isIconicAvailable,
  goalUID,
  fallbackData = {},
  isPlatformGoal
}) => {
  const { key: goalInfoSWRKey, goalInfo } = useGoalInfo(goalUID, {
    fallbackData: fallbackData.goalInfo
  });
  const { key: iconicInfoSWRKey, iconicSubscriptionInfo } =
    useIconicSubscriptionInfo(
      !isK12 && isIconicAvailable ? `iconic-${goalUID}` : null,
      { fallbackData: fallbackData.iconicSubscriptionInfo }
    );
  const goalBenefitsKey = fallbackData?.goalInfo?.isCatalogueFeatureAvailable
    ? 'doubts_and_solutions'
    : goalUID;
  const { key: goalBenefitsSWRKey, goalBenefits } = useGoalBenefits(
    isK12 ? goalBenefitsKey : null,
    { fallbackData: fallbackData.goalBenefits }
  );
  const { key: platformGoalBenefitsSWRKey, platformGoalBenefits } =
    usePlatformGoalBenefits(isPlatformGoal ? goalUID : null, {
      fallbackData: fallbackData.platformGoalBenefits
    });
  const { key: priceHikeSWRKey, priceHikeInfo } = usePriceHikeInfo(null, {
    fallbackData: fallbackData.priceHikeInfo
  });
  const { key: staticContentSWRKey, goalStaticContent } =
    useGoalPageStaticContent(goalUID, {
      fallbackData: fallbackData.staticContent
    });
  const { key: faqSWRKey, faqs } = useGoalFAQs({
    fallbackData: fallbackData.faqs
  });

  return {
    // SWR Keys for caching
    keys: {
      goalInfoSWRKey,
      iconicInfoSWRKey,
      goalBenefitsSWRKey,
      priceHikeSWRKey,
      staticContentSWRKey,
      faqSWRKey,
      platformGoalBenefitsSWRKey
    },
    // Data for usage
    goalInfo,
    iconicSubscriptionInfo,
    goalBenefits,
    priceHikeInfo,
    goalStaticContent,
    faqs,
    platformGoalBenefits
  };
};

export default useFullGoalInfo;
